import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, of } from 'rxjs';
import { AccountGroupService } from '../account-group/account-group.service';
import { SalesContact } from './sales-contact';

export interface SalesContactResponse {
  brandName: string;
  salesMessage: string;
  salesPerson: SalesContact;
}
@Injectable({ providedIn: 'root' })
export class SalesContactService {
  salesContact$$: ReplaySubject<SalesContact> = new ReplaySubject<SalesContact>(1);

  salesContactResponse$$: ReplaySubject<SalesContactResponse> = new ReplaySubject<SalesContactResponse>(1);
  salesContactResponse$: Observable<SalesContactResponse> = this.salesContactResponse$$.asObservable();

  constructor(private http: HttpClient, private accountGroupService: AccountGroupService) {
    this.accountGroupService.currentAccountGroup$.subscribe((accountGroup) => {
      this.salesContactResponse$$.next(undefined);

      const salesPersonEndpoint = '/ajax/v1/account/sales-person/';

      this.http
        .get<{ data: SalesContactResponse }>(salesPersonEndpoint, {
          params: { agid: accountGroup.accountGroupId },
        })
        .pipe(
          map((res) => res.data),
          catchError(() => {
            return of(null);
          }),
        )
        .subscribe((response) => {
          this.salesContactResponse$$.next(response);
          const salesContact: SalesContact = response ? response.salesPerson : null;
          if (salesContact !== null) {
            salesContact.brandName = response.brandName;
            salesContact.salesMessage = response.salesMessage;
          }
          this.salesContact$$.next(salesContact);
        });
    });
  }

  get salesContact$(): Observable<SalesContact> {
    return this.salesContact$$.asObservable();
  }
}
